/**
 * #664 (F71) — the size of a compact badge, in one file.
 *
 * The class `badge` (index.css) has 12 px text and is 20 px tall. A dense row
 * (a boxer row, a bout row, a table cell) needs a smaller badge. Before F71,
 * each badge line wrote the text size and the vertical padding in its own
 * class list, and three shared badges each had their own copy. A size that is
 * stored here changes in ONE place.
 *
 * Add the constant to the class list of the badge, beside `badge` and the
 * tone (`badge-gray`, `badge-amber`). The class names `badge` and
 * `badge-<tone>` stay in the DOM: the specs select by them.
 *
 *   <span className={`badge badge-gray ${BADGE_XS}`}>
 *
 * A site with its own horizontal padding keeps that class beside the constant
 * (`${BADGE_XS} px-1`). The constants are plain utilities, not an `@utility`:
 * two custom utilities that set one property have no sure winner (index.css).
 *
 * The tournament pills never use these constants: every pill of the card and
 * of the header of the tournament page is 12 px (#545, operator 2026-09-30).
 * `badge-size-static.spec.ts` checks it.
 *
 * The operator did not choose one size for all rows. So each constant keeps
 * the look that its sites had.
 */

/** 10 px text, no vertical padding: a boxer row, a bout row, a table cell. */
export const BADGE_XS = 'text-[10px] py-0';

/** 9 px text, no vertical padding: the check-in row, the register list, the print list. */
export const BADGE_XXS = 'text-[9px] py-0';

/** 9 px text with the vertical padding of the badge (py-0.5) and px-1.5: the environment pills and the pills of a ring row.
 *  Each site had px-1.5 before F71, and the default of `badge` is px-2, so the constant holds the narrower padding. */
export const BADGE_XXS_TALL = 'text-[9px] py-0.5 px-1.5';
